require('./ruleAction.tpl.html');
require('./ruleActionController.js');

const RuleActionComponent = {
    templateUrl: '/common/rule/ruleAction/ruleAction.tpl.html',
    controller: 'ruleActionController',
    bindings: {
        ruleAction: '<',
        displayExpression: '<',
        onDeleteSubAction: '&',
        canUserManageFormRules: '<'
    }
};

angular.module('ums')
    .component('uiRuleAction', RuleActionComponent);
